export default __webpack_public_path__ + "static/media/poll_symbol.6605be5e.png";